import React, { useEffect, useState } from "react";
import styles from "./PrivacyPage.module.css";
import { useHistory } from "react-router-dom";

import Header from "../components/Header";
import Loader from "components/Loader";

import { useAccount } from "utils/AccountInfoContext";
import { usePrivacy } from "./usePrivacy";
import mobile from "mobileBridge";
import pdfIcon from "../assets/pdf_Icon.svg";
import CollapsibleShareData from "components/CollapsibleShareData";
import { useTranslation } from "react-i18next";

export function PrivacyPage() {
  const {t} = useTranslation();
  const history = useHistory();

  const { privacyData, directToTCPage, setDirectToTCPage } = useAccount();
  const { data, isLoading, toggleAmway, toggleUpline } = usePrivacy();

  const [date, setDate] = useState("");
  const [showDateSection, setShowDateSection] = useState(false);
  const [shareAmway, setShareAmway] = useState(false);
  const [shareUpline, setShareUpline] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (privacyData) {
      if (privacyData.agreedLatest) {
        const newDate = new Date(privacyData.agreedDate);
        const formattedDate = `${
          newDate.getMonth() + 1
        }.${newDate.getDate()}.${newDate.getFullYear()}`;
        setDate(formattedDate);
        setShowDateSection(true);
      } else {
        setShowDateSection(false);
        if (directToTCPage) {
          setDirectToTCPage(false);
          history.push("/tc");
        }
      }
    }
  }, [privacyData, history, directToTCPage, setDirectToTCPage]);

  useEffect(() => {
    if (data) {
      setShareAmway(data.ShareAmway);
      setShareUpline(data.ShareUpline);
    }
  }, [data]);

  const handleCheck = async (type) => {
    try {
      if (type === "Amway") {
        const newShareAmwayState = !shareAmway;
        await toggleAmway.mutateAsync();
        setShareAmway(newShareAmwayState);
      } else if (type === "Upline") {
        const newShareUplineState = !shareUpline;
        await toggleUpline.mutateAsync();
        setShareUpline(newShareUplineState);
      }
    } catch (error) {
      console.error(t("Error toggling") `${type}:`, error);
    }
  };

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  const pdfSrc = "https://wwg.egnyte.com/dl/ex0jBz9zcQ";

  return (
    <div className={styles.container}>
      <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      {loading ? (
        <div>
          <Loader color={"#415364"} size={85} />
        </div>
      ) : (
        <>
          <div className={styles.pdfContainer}>
            <img
              src={pdfIcon}
              alt="PDF Icon"
              className={styles.privacyIcon}
              // onClick={openPdfInNewWindow}
              onClick={() => {
                mobile.isApp()
                  ? mobile.openLink(pdfSrc)
                  : window.open(pdfSrc, "_blank");
              }}
            />
            <p className={styles.text}>
              {t("Dreambuilders Membership Terms & Conditions")}
            </p>
            {showDateSection && (
              <>
                <div className={styles.divider} />
                <p className={styles.agreedText}>
                  <span className={styles.checkmark}>&#x2714;</span> {t("Agreed on")}{" "}
                  {date}
                </p>
              </>
            )}
            <div className={styles.middleDivider} />
          </div>
          <div className={styles.shareDataContainer}>
            <div className={styles.shareItem}>
              <CollapsibleShareData
                label="Share Data with Amway™"
                shareDataList={[
                  "Premier Membership Status",
                  "Digital Delivery Status",
                  "DreamStream® Status",
                  "Communikate™ Status",
                  "Local Function Attended",
                  "Major Function Attended",
                ]}
                isChecked={shareAmway}
                onCheck={() => handleCheck("Amway")}
                confirmationMessage={t("If you choose not to share this info")}
              />
            </div>
            <div className={styles.dividerBottom} />
            <div className={styles.shareItem}>
              <CollapsibleShareData
                label="Share Data with Upline"
                shareDataList={[
                  "Premier Membership Status",
                  "Digital Delivery Status",
                  "DreamStream® Status",
                  "Communikate™ Status",
                  "Local Function Attended",
                  "Major Function Attended",
                  "Line of Sponsorship (LOS)",
                  "PV",
                  "VCS Percentage",
                ]}
                isChecked={shareUpline}
                onCheck={() => handleCheck("Upline")}
                confirmationMessage={t("If you choose not to share this info with upline")}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PrivacyPage;
